import { Tag } from 'antd'
import BigNumber from 'bignumber.js'
import React from 'react'
import { COLORS } from '../../../constants'
import { TagWrap } from './styles'
import Contracts from '../../PositionColumns/Contracts'
import Price from '../../PositionColumns/Price'
import Unrealizedplpercent from '../../PositionColumns/Unrealizedplpercent'
import MarkPrice from '../../PositionColumns/MarkPrice'
import ClosePosition from '../../PositionColumns/ClosePosition'
import Contracts2 from '../../PositionColumns/Contracts2'
import RealizeDpl from '../../PositionColumns/RealizeDpl'
import EntryTime from '../../PositionColumns/EntryTime'

export const column_position = mutate => {
	return [
		{
			title: '종목',
			dataIndex: 'pairs',
			key: 'pairs',

			render: (text, record) => (
				<Contracts2 data={record} created_at={record?.created_at} />
			),
		},
		{
			title: '상태',
			dataIndex: 'open_close',
			key: 'open_close',
			render: (text, record) => (
				<TagWrap style={{}}>
					<Tag
						style={{
							margin: 0,
							width: '100%',
							flex: 1,
							color:
								text == 'O'
									? COLORS.lightGreen
									: COLORS.lightRed,
						}}>
						{text == 'O' ? '활성' : '종료'}
					</Tag>
					<ClosePosition
						data={record}
						onClick={() => {}}
						onSuccess={() => {
							// 포지션 종료 후 데이터 새로고침
							setTimeout(() => {
								mutate && mutate()
							}, 1000)
						}}
						zindex={1001}
					/>
				</TagWrap>
			),
		},
		{
			title: '구분',
			dataIndex: 'type',
			key: 'type',
			align: 'center',
			width: 70,
			render: (text, record) => (
				<Tag
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignContent: 'center',
						alignItems: 'center',
						color:
							record?.long_short === 'L'
								? COLORS.lightGreen
								: COLORS.lightRed,
					}}>
					{record?.long_short === 'L' ? '매수' : '매도'}
				</Tag>
			),
		},
		{
			title: '평단가',
			dataIndex: 'price',
			key: 'price',
			render: (text, record) => (
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<Price price={text} ep_id={record?.exchange_pairs_id} />
					<MarkPrice data={record} />
				</div>
			),
		},
		{
			title: '수량',
			dataIndex: 'amount',
			key: 'amount',
			width: 95,
			render: (text, record) => (
				<div>{BigNumber(record?.amount || 0).toFormat(3)}</div>
			),
		},
		{
			title: '마진',
			dataIndex: 'margin',
			key: 'margin',
			align: 'right',
			width: 95,
			render: (text, record) => (
				<div>{BigNumber(record?.margin || 0).toFormat(0)}</div>
			),
		},
		{
			title: '미실현손익(%)',
			dataIndex: 'unrealizedplpercent',
			render: (text, data) => <Unrealizedplpercent data={data} />,
		},
		{
			title: '실현손익',
			align: 'center',
			dataIndex: 'realizedpl',
			render: (text, data) => <RealizeDpl data={data} />,
		},
		{
			title: '진입일',
			align: 'center',
			dataIndex: 'entryTime',
			render: (text, data) => (
				<EntryTime time={data?.created_at} offset={0} />
			),
		},
		{
			title: '오버나잇',
			align: 'center',
			dataIndex: 'overnight',
			render: (text, data) => <>{data?.overnight ? 'O' : '-'}</>,
		},
	]
}
